import React, { useState, useEffect } from 'react';
import ConfirmSoldAlert from './ConfirmSoldAlert';
import WinnerInfoAlert from './WinnerInfoAlert';

const SoldInfoModal = (props) => {
console.log('props', props)
  const {
    highBidDetails, saleAsset, belowReserve, bidWon, setShowModal,
    isIf, setIsIf
  } = props;

  const [confirmed, setConfirmed] = useState(!belowReserve)
  const [serviceEntered, setServiceEntered] = useState(
    parseInt(highBidDetails.paddleService?.id) === 5
  );

  useEffect(() => {
    if(confirmed && serviceEntered) {
      console.log('isif', isIf)
      bidWon({ variables: { saleAssetId: saleAsset.id, isIf: isIf }});
      setShowModal(false);
      setIsIf(false);
    }
  }, [confirmed, serviceEntered])

  return (
    <>
      {!confirmed &&
        <ConfirmSoldAlert {...props} setConfirmed={setConfirmed} />
      }
      {confirmed && !serviceEntered &&
        <WinnerInfoAlert {...props} setServiceEntered={setServiceEntered} />
      }
    </>
  )
}

export default SoldInfoModal;